import { ReactComponent as Logo } from './NorlicsLogo.svg';
import { ReactComponent as LogoMobile } from './NorlicsLogoMobile.svg';
import { ReactComponent as MobileMenu } from './mobileMenu.svg';
import { ReactComponent as ArrowIcon } from './arrowIcon.svg';
import { ReactComponent as HeaderBadge } from './header-badge.svg';

import { ReactComponent as X } from './x.svg';
import { ReactComponent as Facebook } from './facebook.svg';
import { ReactComponent as Instagram } from './instagram.svg';

import { ReactComponent as OurOfficeIcon } from './our-office-icon.svg';
import { ReactComponent as TalkWithUsIcon } from './talk-with-us-icon.svg';
import { ReactComponent as SendUsMailIcon } from './send-us-mail-icon.svg';
import { ReactComponent as LinksConnectedToUsIcon } from './links-connected-to-us-icon.svg';

import { ReactComponent as AlertIcon } from './alert.svg';

export {
    Logo,
    MobileMenu,
    LogoMobile,
    ArrowIcon,
    HeaderBadge,

    Facebook,
    Instagram,
    X,

    OurOfficeIcon,
    TalkWithUsIcon,
    SendUsMailIcon,
    LinksConnectedToUsIcon,

    AlertIcon
}